/* tslint:disable:no-var-requires */

const LocalForage = require('localforage');

// import LocalForage from "localforage";
import { Observable } from 'rxjs/Observable';
import { IStorageItem } from './storage-item.interface';
import { Model } from '../common/model';

import 'rxjs/add/observable/fromPromise';

export class DatabaseCollection {
  private _instance: any;

  constructor(public name: string) {
    this._instance = LocalForage.createInstance({
      name
    });
  }

  public getById(id: string): Observable<any> {
    return Observable.fromPromise(
      this._instance.getItem(id).then((item: IStorageItem) => {
        if (item && item.ttl && item.ttl < Date.now()) {
          this._instance.removeItem(id).then(() => {
            return Promise.resolve(null);
          });
        } else {
          return Promise.resolve(item && item.value);
        }
      })
    );
  }

  public static generateId(name: string) {
    const buf: any = [];
    const chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charLen = chars.length;

    for (let i = 0; i < 24; ++i) {
      buf.push(chars[Math.floor(Math.random() * (charLen + 1))]);
    }

    return 'loc_' + buf.join('') + '_' + name;
  }

  public save(
    key: string,
    value: any,
    ttl?: number,
    timestamp?: number
  ): Observable<any> {
    if (!key || key === undefined || key == null) {
      key = DatabaseCollection.generateId(this.name);
    }

    if (value && typeof value.toStoreObject === 'function') {
      value = value.toStoreObject();
    }

    const storeObject: IStorageItem = { key, value };

    if (ttl && ttl != -1) {
      timestamp = timestamp == null ? Date.now() : timestamp * 1000;
      storeObject.ttl = timestamp + ttl * 1000;
    }

    return this.getById(key).map((element) => {
      let storedItem: any = {};
      if (element) {
        const keys = Object.keys(storeObject);

        for (let i = 0; i < keys.length; i++) {
          const keyValue: string = keys[i];
          storedItem[keyValue] = storeObject[keyValue];
        }
      } else {
        storedItem = value;
      }

      this._instance.setItem(key, storeObject);

      return storedItem;
    });
  }

  public saveLocal(key: string, value: any): Observable<any> {
    let isNew = false;

    if (!key || key === undefined || key == null) {
      key = DatabaseCollection.generateId(this.name);
      isNew = true;
    }

    if (value && typeof value.toStoreObject === 'function') {
      value = value.toStoreObject();
    }

    const storeObject: IStorageItem = {
      isNew,
      key,
      value: Object.assign({}, value, { _id: key })
    };

    return this.getById(key).map((element) => {
      if (element) {
        storeObject.value = Object.assign({}, element, storeObject.value);
      }

      this._instance.setItem(key, storeObject);

      return storeObject;
    });
  }

  public list(): Observable<any> {
    const data: any = [];

    return Observable.fromPromise(
      this._instance
        .iterate((value: any) => {
          data.push(value);
        })
        .then(() => {
          return data;
        })
    );
  }

  public removeById(id: string): Observable<any> {
    return Observable.fromPromise(
      this._instance.removeItem(id).then(() => {
        return Promise.resolve();
      })
    );
  }

  public clear() {
    this._instance.clear();
  }
}
